import { gql } from '@apollo/client';

import { threadFragment } from '../fragments';

export default gql`
  mutation UpdateThread(
    $courseId: String!
    $threadId: String!
    $input: UpdateThreadInput!
  ) {
    updateThread(courseId: $courseId, threadId: $threadId, input: $input)
      @rest(
        type: "Thread"
        path: "courses/{args.courseId}/threads/{args.threadId}"
        method: "PUT"
      ) {
      ...Thread
    }
  }
  ${threadFragment}
`;
